<template>
    <div>
        <el-select v-model="izbranPrikljucek"
                    placeholder="Izberite priključek"
                    :disabled="disabled"
                    no-data-text="Nimate povezanih priključkov"
                    v-if="podatkiIzbirnika.length > 0">
            <el-option v-for="(data) in podatkiIzbirnika"
                       :label="data.naziv"
                       :key="data.id"
                       :value="data.id">
            </el-option>
        </el-select>
    </div>
</template>
<script>
  import ClientAgent from '../../../../assets/js/clientAgent.js'
  import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
  import {Select, Option} from 'element-ui'
  import {PridobiStranko} from 'src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
  import PrivzetaVrednostLogic from '../../../../assets/js/globalne_funkcije/PrivzetaVrednostLogic'
  export default {
    name: 'IzbirnikPrikljuckov',
    mixins: [GetPodatkiIzbirnika, PridobiStranko],
    data () {
      return {
        clientAgent: null,
        seznamPrikljuckov: [],
        podatkiIzbirnika: [],
        izbranPrikljucek: null,
        izbranPrikljucekVsebina: '',
        podatkiPrikljucka: [],
        tipPrivzeteVrednosti: ''
      }
    },
    props: {
      selectorPermissions: null,
      disabled: false
    },
    watch: {
      izbranPrikljucek: function (prikljucekId) {
        this.PosodbiPodatkePrikljucka(prikljucekId)
      },
      selectorPermissions: function () {
        this.FetchData()
      }
    },
    components: {
      [Option.name]: Option,
      [Select.name]: Select
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.FetchData()
    },
    methods: {
      FetchData () {
        let param = {}
        param.vmesnik = this
        param.filter = this.filter
        param.permissions = this.selectorPermissions
        this.PridobiPodatkeIzbirnika(param)
      },
      PosodbiPodatkePrikljucka (prikljucekId) {
        if (prikljucekId !== null) {
          let iskanPrikljucek = this.PrikljucekObstajaVSeznamu(prikljucekId, true)
          if (iskanPrikljucek !== false) {
            this.podatkiPrikljucka = iskanPrikljucek
          }
        }
        this.$emit('osvezitevIzbranPrikljucek', this.izbranPrikljucek)
        this.$emit('osvezitevIzbranSeznamPrikljuckov', this.podatkiPrikljucka)
      },
      PrenosniPodatki (podatki, prenosniParam) {
        if (prenosniParam.defaultConnectorType !== 'undefined') {
          this.tipPrivzeteVrednosti = prenosniParam.defaultConnectorType
        }
        this.seznamPrikljuckov = podatki.data
        this.podatkiIzbirnika = podatki.selectorData
        if (this.izbranPrikljucek !== null && this.PrikljucekObstajaVSeznamu(this.izbranPrikljucek)) {
          return true
        }
        if (this.seznamPrikljuckov.length > 0) {
          let shranjenPrivzetPrikljucek = PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(this.tipPrivzeteVrednosti)
          if (shranjenPrivzetPrikljucek !== null) {
            if (this.PrikljucekObstajaVSeznamu(shranjenPrivzetPrikljucek)) {
              this.izbranPrikljucek = shranjenPrivzetPrikljucek
            } else { // ce ga ni v seznamu, osvezi seznam
              this.GetUserData() // callback je PrenosniPodatkiStranka
            }
          } else {
            this.GetUserData() // callback je PrenosniPodatkiStranka
          }
        }
      },
      PrenosniPodatkiStranka () {
        let shranjenPrivzetPrikljucek = PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(this.tipPrivzeteVrednosti)
        if (this.PrikljucekObstajaVSeznamu(shranjenPrivzetPrikljucek)) {
          this.izbranPrikljucek = PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(this.tipPrivzeteVrednosti)
        } else if (this.seznamPrikljuckov.length > 0) {
          this.izbranPrikljucek = this.seznamPrikljuckov[0].id_prikljucek
        }
      },
      PrikljucekObstajaVSeznamu (iskanPrikljucek, returnData = false) {
        for (const index in this.seznamPrikljuckov) {
          if (this.seznamPrikljuckov[index].id_prikljucek === iskanPrikljucek) {
            if (returnData) {
              return this.seznamPrikljuckov[index]
            }
            return true
          }
        }
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GlobalneKomponente/IzbirnikPrikljuckov.vue